import { FC, useState } from 'react'
import { CirclePlus } from 'lucide-react'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover'
import { Button } from '@/components/ui/button.tsx'
import { usePois } from '@/js/editor/hooks/api/usePois.ts'
import { Input } from '@/components/ui/input.tsx'
import { Label } from '@/components/ui/label.tsx'
import { Textarea } from '@/components/ui/textarea.tsx'
import { toast } from 'sonner'
import { Poi } from '@/js/types'

type AddPoiProps = {
    onPoiCreated: (newPoi: Poi) => void
}

export const AddPoi: FC<AddPoiProps> = ({ onPoiCreated }) => {
    const [color, setColor] = useState('var(--color-mm-gray)')
    const [title, setTitle] = useState('')
    const [description, setDescription] = useState('')
    const [isOpen, setIsOpen] = useState(false)

    const { createPoi } = usePois()
    const onSave = () => {
        createPoi({
            title,
            description,
        })
            .then((newPoi) => {
                setIsOpen(false)
                setTitle('')
                setDescription('')
                toast.success(title + ' wurde erfolgreich erstellt!', {
                    description: 'Füge dem Eintrag Markierungen auf der Karte hinzu.',
                })
                onPoiCreated(newPoi)
            })
            .catch((error) => {
                console.error(error)
                const errorMessage =
                    error?.response?.status === 419
                        ? 'Deine Sitzung ist abgelaufen. Bitte aktualisiere die Seite und versuche es erneut.'
                        : 'Es ist ein Problem aufgetreten. Der Eintrag konnte nicht erstellt werden. Bitte aktualisiere die Seite und versuche es erneut.'
                toast.error('Erstellen fehlgeschlagen', {
                    description: errorMessage,
                })
            })
    }

    return (
        <Popover open={isOpen} onOpenChange={setIsOpen}>
            <PopoverTrigger asChild>
                <CirclePlus
                    color={color}
                    size={18}
                    className={'cursor-pointer transition-all'}
                    onMouseEnter={() => setColor('var(--color-mm-gray2)')}
                    onMouseLeave={() => setColor('var(--color-mm-gray)')}
                    onClick={() => setIsOpen(true)}
                />
            </PopoverTrigger>
            <PopoverContent className={'z-2005'}>
                <div className="flex flex-col gap-6">
                    <div className="grid w-full max-w-sm items-center gap-1.5">
                        <Label htmlFor="title">Titel</Label>
                        <Input id="title" type="text" placeholder="Titel" onChange={(e) => setTitle(e.target.value)} />
                    </div>
                    <div className="grid w-full max-w-sm items-center gap-1.5">
                        <Label htmlFor="description">Kurzbeschreibung</Label>
                        <Textarea
                            placeholder="Beschreibung"
                            id="description"
                            onChange={(e) => setDescription(e.target.value)}
                        />
                    </div>
                    <div className="flex justify-between gap-6">
                        <Button className={'flex-1'} variant={'secondary'} onClick={() => setIsOpen(false)}>
                            Abbrechen
                        </Button>
                        <Button className={'flex-1'} onClick={onSave}>
                            Speichern
                        </Button>
                    </div>
                </div>
            </PopoverContent>
        </Popover>
    )
}
